module.exports = __webpack_public_path__ + "img/example-security-measures-arrows.68b77bce.png";